/**
 * 新建标签表单组件
 */


import { zodResolver } from "@hookform/resolvers/zod";
import { Loader2 } from "lucide-react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import { z } from "zod";

import { useCreateTagMutation } from "@/modules/mine";
import type { DialogComponentProps } from "@/shared/components/dialog";
import { Button } from "@/shared/ui/button";
import { DialogFooter } from "@/shared/ui/dialog";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/shared/ui/form";
import { Input } from "@/shared/ui/input";

type CreateTagResult = {
  action: "created";
};

export function CreateTag({ close, resolve }: DialogComponentProps<CreateTagResult>) {
  const createTagMutation = useCreateTagMutation();
  
  // 表单验证规则
  const formSchema = z.object({
    name: z.string()
      .min(1, { message: "标签名称不能为空" })
      .max(30, { message: "标签名称不能超过30个字符" }),
  });

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: "",
    },
  });

  function onSubmit(values: z.infer<typeof formSchema>) {
    createTagMutation.mutate(
      { name: values.name },
      {
        onSuccess: () => {
          form.reset();
          toast.success("标签创建成功");
          resolve({ action: "created" });
        },
      },
    );
  }

  return (
    <>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
          {/* 标签名称 */}
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="text-xs text-muted-foreground">标签名称</FormLabel>
                <FormControl>
                  <Input {...field} placeholder="请输入标签名称" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </form>
      </Form>

      <DialogFooter>
        <Button
          type="button"
          variant="outline"
          onClick={close}
          disabled={createTagMutation.isPending}
        >
          取消
        </Button>
        <Button
          type="button"
          onClick={form.handleSubmit(onSubmit)}
          disabled={createTagMutation.isPending}
        >
          确认
          {createTagMutation.isPending && <Loader2 className="animate-spin" />}
        </Button>
      </DialogFooter>
    </>
  );
}
